import {BrowserModule} from '@angular/platform-browser';
import {APP_INITIALIZER, LOCALE_ID, NgModule} from '@angular/core';

import {AppRoutingModule} from './app-routing.module';
import {AppComponent} from './app.component';
import {HTTP_INTERCEPTORS, HttpClientModule} from '@angular/common/http';
import {DecimalPipe, registerLocaleData} from '@angular/common';
import localeFr from '@angular/common/locales/fr';
import * as moment from 'moment';
import {AppConfigService} from './shared/services/app-config.service';
import {AuthInterceptor} from './shared/auth.interceptor';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {ReactiveFormsModule} from '@angular/forms';
import {configure} from 'mobx';
import {Chart} from 'chart.js';
import * as ChartDataLabels from 'chartjs-plugin-datalabels';
import {ServiceWorkerModule} from '@angular/service-worker';
import {environment} from '../environments/environment';
import {MatSnackBarModule} from '@angular/material';
import {PwaService} from './shared/services/pwa.service';

const appInitializerFn = (appConfigService: AppConfigService, pwaService: PwaService) => {
  return () => {
    pwaService.startUpdateChecks();
    return appConfigService.load();
  };
};

@NgModule({
  declarations: [
    AppComponent,
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    HttpClientModule,
    ReactiveFormsModule,
    ServiceWorkerModule.register( './ngsw-worker.js', { enabled: environment.production }),
    MatSnackBarModule
  ],
  providers: [
    DecimalPipe,
    { provide: LOCALE_ID, useValue: 'fr-FR' },
    {
      provide: APP_INITIALIZER,
      useFactory: appInitializerFn,
      multi: true,
      deps: [AppConfigService, PwaService]
    },
    { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true }
  ],
  bootstrap: [AppComponent]
})
export class AppModule {
  constructor() {
    registerLocaleData(localeFr, 'fr-FR');
    moment.locale('fr');
    // mobx conf
    configure({
      enforceActions: 'observed'
    });
    Chart.plugins.unregister(ChartDataLabels);
  }
}
